// Imports ------------------------------------------------------------------->

import {Component, attr} from "../Component";
import {element} from "../CustomElement";

import {Page} from "../flipp-page/Page";
import {LoadingAnimation} from "../flipp-loading/LoadingAnimation";

// Private Definitions ------------------------------------------------------->

interface CouponsPageChunk {
	CouponsPage: Component<any, any>;
}

// Public Definitions -------------------------------------------------------->

@element("flipp-coupons-page-entry")
export class CouponsPageEntry extends Component<{category?: string}, CouponsPageChunk> {

	private static chunkLoaded = false;

	@attr category: string;

	state = {
		scrollTop: 0
	};

	refs: {
		page: HTMLElement;
	};

	onAttach() {
		this.refs.page.scrollTop = this.state.scrollTop;
	}

	onRender() {
		this.refs.page.scrollTop = this.state.scrollTop;
	}

	onAttributeChange(name: string, oldVal: string, newVal: string) {
		super.onAttributeChange(name, oldVal, newVal);

		if (name === "category") this.state.scrollTop = 0;
	}

	prepare() {
		return new Promise<CouponsPageChunk>((resolve, reject) => {
			require.ensure(["./CouponsPage"], () => {
				// tslint:disable-next-line:no-require-imports
				const chunk = require("./CouponsPage") as CouponsPageChunk;
				CouponsPageEntry.chunkLoaded = true;
				resolve(chunk);
			});
		});
	}

	renderLoading() {
		if (CouponsPageEntry.chunkLoaded) {
			return null;
		}

		return <Page ref="page" show="coupons" onScroll={this._handleScroll}>
			<div flex-vertical fill-absolute>
				<section class="main">
					<LoadingAnimation />
				</section>
			</div>
		</Page>;
	}

	render(model: CouponsPageChunk) {
		const CouponsPage = model.CouponsPage as any;
		return <Page ref="page" show="coupons" onScroll={this._handleScroll}>
			<CouponsPage category={this.category} />
		</Page>;
	}

	private _handleScroll = (e: Event) => {
		this.state.scrollTop = this.refs.page.scrollTop;
	}

}
